import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {...state, loadGetAzubisWithAbteilungen: true}
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    azubisWithAbteilungen: result,
    loadGetAzubisWithAbteilungen: false,
  }
}

export function rejected(state) {
  return {
    ...state,
    loadGetAzubisWithAbteilungen: false,
  }
}

export async function action(payload) {
  try {
    return await Api.getAzubisWithAbteilungenAsAusbilder(payload.azubiIds)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
